import { render, staticRenderFns } from "./Notic2.vue?vue&type=template&id=fb905db4&scoped=true"
import script from "./Notic2.vue?vue&type=script&lang=js"
export * from "./Notic2.vue?vue&type=script&lang=js"
import style0 from "./Notic2.vue?vue&type=style&index=0&id=fb905db4&prod&scoped=true&lang=scss"
import style1 from "./Notic2.vue?vue&type=style&index=1&id=fb905db4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb905db4",
  null
  
)

export default component.exports